import React from "react";
import { connect } from "react-redux";
import { yodaCatalogueActions } from "../logic/actions";
import {
  isMobile,
  isTablet,
  browserName,
  browserVersion,
  osName,
  osVersion,
} from "react-device-detect";
import PropTypes from "prop-types";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.warn("B2B application error");
    if (process.env.NODE_ENV === "development" || this.props.disableLogs)
      return this.props?.onCatch?.(error, info);

    const now = new Date();
    let log = {
      message: error?.message,
      timeStamp: now.getTime(),
      type: "runtime",
      stackTrace: `${error?.message} ${info?.componentStack}`,
      deviceType: isMobile ? "mobile" : isTablet ? "tablet" : "desktop",
      browserName,
      browserVersion,
      osName,
      osVersion,
    };
    if (this.props.user) {
      log.user = {
        id: this.props.user?.id,
        role: this.props.user?.role,
      };
    }
    if (window) {
      log.pathname = window.location?.pathname;
      log.href = window.location?.href;
      log.localStorage = window.localStorage;
      log.window = {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        scrollY: window.scrollY,
        scrollX: window.scrollX,
        orientation: window.screen?.orientation?.type,
      };
    }
    this.props.sendLog({ error: log });
    this.props?.onCatch?.(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  fallback: PropTypes.any,
  disableLogs: PropTypes.bool,
};

function mapStateToProps(state) {
  const { me: user } = state.yodaStakeholders;
  return {
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendLog: (payload) => dispatch(yodaCatalogueActions.sendLog(payload)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
